import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/needle-ab.png';
import _imports_1 from '@/assets/cd.png';
const _withScopeId = n => (_pushScopeId("data-v-5579c5b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "detailTop"
};
const _hoisted_3 = {
  class: "detailTopLeft"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-zuojiantou"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "leftMarquee"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-youjiantou"
})], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detailTopRight"
}, [/*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-fenxiang-copy"
})])], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "img_cd"
}, null, -1));
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "detailFooter"
};
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"footerTop\" data-v-5579c5b8><svg class=\"icon\" aria-hidden=\"true\" data-v-5579c5b8><use xlink:href=\"#icon-aixin\" data-v-5579c5b8></use></svg><svg class=\"icon\" aria-hidden=\"true\" data-v-5579c5b8><use xlink:href=\"#icon-xiazai\" data-v-5579c5b8></use></svg><svg class=\"icon\" aria-hidden=\"true\" data-v-5579c5b8><use xlink:href=\"#icon-yinlechangpian\" data-v-5579c5b8></use></svg><svg class=\"icon\" aria-hidden=\"true\" data-v-5579c5b8><use xlink:href=\"#icon-iconfontzhizuobiaozhun023110\" data-v-5579c5b8></use></svg><svg class=\"icon\" aria-hidden=\"true\" data-v-5579c5b8><use xlink:href=\"#icon-liebiao-\" data-v-5579c5b8></use></svg></div>", 1);
const _hoisted_13 = {
  class: "footerContenter"
};
const _hoisted_14 = ["max"];
const _hoisted_15 = {
  class: "footer"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-danxunhuan"
})], -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-shangyishoushangyige"
}, null, -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-bofang"
}, null, -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-zanting"
}, null, -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-xiayigexiayishou"
}, null, -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("use", {
  "xlink:href": "#icon-zu"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Vue3Marquee = _resolveComponent("Vue3Marquee");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("img", {
    src: $props.musicList.al.picUrl,
    alt: "",
    class: "bgImg"
  }, null, 8, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock("svg", {
    class: "icon",
    "aria-hidden": "true",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.backHome && $options.backHome(...args))
  }, _hoisted_5)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_Vue3Marquee, {
    style: {
      "color": "#fff"
    }
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.musicList.name), 1)]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.musicList.ar, (item, i) => {
    return _openBlock(), _createElementBlock("span", {
      key: i
    }, _toDisplayString(item.name), 1);
  }), 128)), _hoisted_7])]), _hoisted_8]), _withDirectives(_createElementVNode("div", {
    class: "detailContent",
    onClick: _cache[1] || (_cache[1] = $event => $data.isLyricShow = !$data.isLyricShow)
  }, [_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: _normalizeClass(["img_needle", {
      img_needle_active: !$props.isbtnShow
    }])
  }, null, 2), _hoisted_9, _createElementVNode("img", {
    src: $props.musicList.al.picUrl,
    alt: "",
    class: _normalizeClass(["img_ar", [$props.isbtnShow ? 'img_ar_paused' : 'img_ar_active']])
  }, null, 10, _hoisted_10)], 512), [[_vShow, !$data.isLyricShow]]), _withDirectives(_createElementVNode("div", {
    class: "musicLyric",
    ref: "musicLyric",
    onClick: _cache[2] || (_cache[2] = $event => $data.isLyricShow = !$data.isLyricShow)
  }, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.lyric, item => {
    return _openBlock(), _createElementBlock("p", {
      key: item,
      class: _normalizeClass({
        active: _ctx.currentTime * 1000 >= item.time && _ctx.currentTime * 1000 <= item.next
      })
    }, _toDisplayString(item.lrc), 3);
  }), 128))])], 512), [[_vShow, $data.isLyricShow]]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
    type: "range",
    class: "range",
    ref: "range",
    min: "0",
    max: _ctx.duration,
    step: "0.05",
    onChange: _cache[3] || (_cache[3] = (...args) => $options.changeBar && $options.changeBar(...args)),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.currentTime = $event)
  }, null, 40, _hoisted_14), [[_vModelText, _ctx.currentTime]])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, (_openBlock(), _createElementBlock("svg", {
    class: "icon",
    "aria-hidden": "true",
    onClick: _cache[5] || (_cache[5] = $event => $options.switchSong(-1))
  }, _hoisted_18)), $props.isbtnShow ? (_openBlock(), _createElementBlock("svg", {
    key: 0,
    class: "icon bofang",
    "aria-hidden": "true",
    onClick: _cache[6] || (_cache[6] = (...args) => $props.playMusic && $props.playMusic(...args))
  }, _hoisted_20)) : (_openBlock(), _createElementBlock("svg", {
    key: 1,
    class: "icon bofang",
    "aria-hidden": "true",
    onClick: _cache[7] || (_cache[7] = (...args) => $props.playMusic && $props.playMusic(...args))
  }, _hoisted_22)), (_openBlock(), _createElementBlock("svg", {
    class: "icon",
    "aria-hidden": "true",
    onClick: _cache[8] || (_cache[8] = $event => $options.switchSong(1))
  }, _hoisted_24)), _hoisted_25])])], 64);
}